import { Injectable } from '@angular/core';

/*
  Generated class for the HelperProvider provider.

  See https://angular.io/guide/dependency-injection for more info on providers
  and Angular DI.
*/

@Injectable()
export class HelperProvider
{

   /** ----- Constructor ----- **/

   constructor() {}


   /** ----- Public Methods ----- **/

   tConvert( inTime )
   {
      // Check correct time format and split into components
      inTime = inTime.toString ().match (/^([01]\d|2[0-3])(:)([0-5]\d)(:[0-5]\d)?$/) || [inTime];

      if (inTime.length > 1) { // If time format correct
         inTime = inTime.slice (1);  // Remove full string match value
         inTime[5] = +inTime[0] < 12 ? ' AM' : ' PM'; // Set AM/PM
         inTime[0] = +inTime[0] % 12 || 12; // Adjust hours
      }
      let output = inTime[0] + inTime[1] + inTime[2] + inTime[5];
      return output; // return adjusted time or original string
   }

   fullTimeConvert(inTimeStr, subEightHour = false) {
      if (inTimeStr != null) {
        let timeStrs = inTimeStr.split(/[- :]/);
        let date = new Date(
          timeStrs[0],
          timeStrs[1] - 1,
          timeStrs[2],
          timeStrs[3],
          timeStrs[4],
          timeStrs[5]
        );
        if(!subEightHour)
          date.setHours(date.getHours() + 8);
        let hour = date.getHours() < 10 ? "0" + date.getHours() : date.getHours();
        let min =
          date.getMinutes() < 10 ? "0" + date.getMinutes() : date.getMinutes();
        let sec =
          date.getSeconds() < 10 ? "0" + date.getSeconds() : date.getSeconds();
        return this.tConvert(hour + ":" + min + ":" + sec);
      } else {
        return "";
      }
    }

}



// WEBPACK FOOTER //
// ./src/providers/helper/helper.ts